export default {
  computed: {
    isLoading() {
      return this.$store.state.config.loadingArray.length > 0;
    },
  },
  methods: {
    doPrintById(id) {
      // Get HTML to print from element
      const prtHtml = document.getElementById(id).innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = '';
      // eslint-disable-next-line no-restricted-syntax
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0 hide');

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          <div class="v-application  v-application--is-ltr theme--light">
            <div class="v-application--wrap"> 
              <div>         
                ${prtHtml}
              </div>
            </div>
          </div>
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    selectorLabel(value, selector) {
      // value取得選擇器label
      if (selector === undefined) return '';
      const r = selector.find((x) => x.value === value);
      if (r === undefined) return '';
      return r.label;
    },
    selectorCustName(value, selector) {
      // value取得選擇器label
      if (selector === undefined) return '';
      const r = selector.find((x) => x.value === value);
      if (r === undefined) return '';
      return r.cust_name;
    },
    isNullOrEmpty(value) {
      // 判斷是否為null, undefinde, ''

      return value === null || value === undefined || value.trim() === '';
    },
    isNullOrEmptyNum(value) {
      // 判斷是否為null, undefinde, 0

      return value === null || value === undefined || value === 0;
    },
    dayjsToTWDate(value, format = 'MMDD') {
      return value.format('YYYY') - 1911 + value.format(format);
    },
    extToMimeType(value) {
      // 副檔名轉為MIME Type

      const extMappingMine = {
        jpg: 'image/jpeg',
        pdf: 'application/pdf',
        xls: 'application/vnd.ms-excel',
      };

      return extMappingMine[value];
    },
    doGetSyllabusPDF(yms, sel) {
      const _arg = yms.split('@');
      const params = {
        year: _arg[0],
        sms: _arg[1],
        selcode: sel,
      };
      $api.s32.S32W1005_GetPDF(params).then((res) => {
        const blob = new Blob([res], { type: this.extToMimeType('pdf') });
        const href = window.URL.createObjectURL(blob);
        if (_arg[2] !== '') {
          // source v-dialog v-model value
          // this.syllbusDialog = true;
          // return href;
        }
        if (!_arg[2]) {
          const _left = (window.screen.availWidth - 1024) / 2;
          const _top = (window.screen.availHeight - Math.round(window.screen.availHeight * 0.98)) / 2;
          window.open(href, '', `top=${_top},left=${_left},width=1024,height=${Math.round(window.screen.availHeight * 0.98)},toolbar=0,scrollbars=on,status=0 hide`); // 直接開pdf在螢幕中央新頁面
        }
      });
    },
    toAmountValue(value, toFixed = 0) {
      // 回傳會計金額
      if (value === 'NaN') value = '0';

      const sign = Number(value) < 0 ? -1 : 1;
      const valueToFixed = Math.round(Number(value) * 10 ** toFixed * sign) / (10 ** toFixed * sign);
      if (toFixed === 0) {
        return Number(valueToFixed)
          .toString()
          .replace(/(\d)(?=(\d{3})+$)/g, '$1,');
      }
      const val = valueToFixed.toFixed(toFixed).toString().split('.');
      val[0] = (valueToFixed < 0 && valueToFixed > -1 ? '-' : '')
        + Number(val[0])
          .toString()
          .replace(/(\d)(?=(\d{3})+$)/g, '$1,');
      return val.join('.');
    },
    compressImage(file, maxSizeMB = 2) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          const img = new Image();
          img.src = event.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            let { width } = img;
            let { height } = img;

            // 限制最大寬高避免過大
            const maxDimension = 1920;
            if (width > maxDimension || height > maxDimension) {
              if (width > height) {
                height = Math.round((height * maxDimension) / width);
                width = maxDimension;
              } else {
                width = Math.round((width * maxDimension) / height);
                height = maxDimension;
              }
            }

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            let quality = 0.9;
            let dataUrl = canvas.toDataURL('image/jpeg', quality);

            const dataURLtoFile = (dataurl, filename) => {
              const arr = dataurl.split(',');
              const mime = arr[0].match(/:(.*?);/)[1];
              const bstr = atob(arr[1]);
              let n = bstr.length;
              const u8arr = new Uint8Array(n);
              while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
              }
              return new File([u8arr], filename, { type: mime });
            };

            let compressedFile = dataURLtoFile(dataUrl, file.name);

            // 迴圈動態調降品質直到小於目標大小
            while (compressedFile.size > maxSizeMB * 1024 * 1024 && quality > 0.3) {
              quality -= 0.05;
              dataUrl = canvas.toDataURL('image/jpeg', quality);
              compressedFile = dataURLtoFile(dataUrl, file.name);
            }

            resolve(compressedFile);
          };
          img.onerror = (error) => reject(error);
        };
        reader.onerror = (error) => reject(error);
      });
    },
  },
};
